import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../menu";
import { Modal, Button, Form, Table, Spinner, Row, Col } from "react-bootstrap";

export default function Update() {
  const [lista, setLista] = useState([]);
  const [versoes, setVersoes] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [sistema, setSistema] = useState("");
  const [versao, setVersao] = useState("");
  const [arquivo, setArquivo] = useState(null);
  const [itemSelecionado, setItemSelecionado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);

  // novos estados
  const [busca, setBusca] = useState("");
  const [filtroSistema, setFiltroSistema] = useState("");
  const [modo, setModo] = useState("upload"); // "upload" ou "versao"

  // Mapeamento dos sistemas
  const sistemasMap = {
    CSMotors: 183,
    CSJoias: 174,
    CSImob: 104,
  };

  // Carregar lista da API
  useEffect(() => {
    const fetchLista = async () => {
      try {
        const response = await axios.get(
          "http://csapi.compsoft.com.br:9123/update/lista",
          {
            auth: {
              username: "CloudShared",
              password: "CloudShared@1163",
            },
          }
        );
        setLista(response.data);

        response.data.forEach((item) => {
          buscarVersao(item.cnpj, item.controle);
        });
      } catch (error) {
        console.error("Erro ao carregar lista:", error);
      }
    };

    fetchLista();
  }, []);

  // Buscar versão atual
  const buscarVersao = async (cnpj, sistemaNum) => {
    try {
      const resp = await axios.get(
        `http://csapi.compsoft.com.br:9123/upload/update/${cnpj}/${sistemaNum}`,
        {
          auth: {
            username: "CloudShared",
            password: "CloudShared@1163",
          },
          responseType: "text",
        }
      );

      if (resp.status === 200) {
        setVersoes((prev) => ({
          ...prev,
          [cnpj + "_" + sistemaNum]: resp.data.trim(),
        }));
      }
    } catch (err) {
      if (err.response && err.response.status !== 404) {
        console.error("Erro buscando versão:", err);
      }
      setVersoes((prev) => ({
        ...prev,
        [cnpj + "_" + sistemaNum]: "-",
      }));
    }
  };

  // abrir modal (decide modo)
  const abrirModal = (item, tipo = "upload") => {
    setItemSelecionado(item);
    setSistema(item.descricao?.trim() || "CSMotors");
    setModo(tipo);

    const versoesDoSistema = lista
      .filter((it) => it.descricao === item.descricao)
      .map((it) => versoes[it.cnpj + "_" + it.controle])
      .filter((v) => v !== undefined && v !== "-" && !isNaN(v));

    const maior = versoesDoSistema.length
      ? Math.max(...versoesDoSistema.map((v) => parseInt(v)))
      : 0;

    if (tipo === "upload") {
      setVersao(String(maior + 1)); // Upload sempre cria a próxima versão
    } else {
      setVersao(String(maior)); // Alterar mostra a versão atual (sem +1)
    }

    setModalOpen(true);
  };

  const fecharModal = () => {
    setModalOpen(false);
    setArquivo(null);
    setVersao("");
    setItemSelecionado(null);
    setLoading(false);
    setSucesso(false);
  };

  // submit genérico (POST ou PUT)
  const handleSubmit = async (e) => {
    e.preventDefault();
    const sistemaNum = sistemasMap[sistema] || 0;

    if (!sistemaNum) {
      alert("Sistema não reconhecido!");
      return;
    }

    try {
      setLoading(true);

      if (modo === "upload") {
        if (!arquivo) {
          alert("Escolha um arquivo!");
          setLoading(false);
          return;
        }
        const formData = new FormData();
        formData.append("arquivo", arquivo);

        await axios.post(
          `http://csapi.compsoft.com.br:9123/upload/update/${itemSelecionado.cnpj}/${sistemaNum}/${versao}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
            auth: {
              username: "CloudShared",
              password: "CloudShared@1163",
            },
          }
        );
      } else {
        // PUT apenas altera versão, sem arquivo
        await axios.put(
          `http://csapi.compsoft.com.br:9123/upload/update/${itemSelecionado.cnpj}/${sistemaNum}/${versao}`,
          {},
          {
            auth: {
              username: "CloudShared",
              password: "CloudShared@1163",
            },
          }
        );
      }

      await buscarVersao(itemSelecionado.cnpj, sistemaNum);

      setSucesso(true);
      setTimeout(() => {
        setSucesso(false);
        fecharModal();
      }, 1000);
    } catch (err) {
      console.error(err);
      alert("Erro ao atualizar versão!");
      setLoading(false);
    }
  };

  // aplica busca e filtro
  const listaFiltrada = lista.filter((item) => {
    const matchNome = item.nome.toLowerCase().includes(busca.toLowerCase());
    const matchSistema =
      !filtroSistema || item.descricao === filtroSistema;
    return matchNome && matchSistema;
  });

  // lista única de sistemas
  const sistemasUnicos = [...new Set(lista.map((i) => i.descricao))];

  return (
    <>
      <Menu />

      <div className="container" style={{ marginTop: "70px" }}>
        {/* Busca e filtro */}
        <Row className="mb-3">
          <Col md={6}>
            <Form.Control
              type="text"
              placeholder="Buscar por nome..."
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
            />
          </Col>
          <Col md={4}>
            <Form.Select
              value={filtroSistema}
              onChange={(e) => setFiltroSistema(e.target.value)}
            >
              <option value="">Todos os sistemas</option>
              {sistemasUnicos.map((s, idx) => (
                <option key={idx} value={s}>
                  {s}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>

        {/* Tabela */}
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>CNPJ</th>
              <th>Nome</th>
              <th>Sistema</th>
              <th>Versão Disponível</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {listaFiltrada.map((item, idx) => {
              const chave = item.cnpj + "_" + item.controle;
              return (
                <tr key={idx}>
                  <td>{item.cnpj}</td>
                  <td>{item.nome}</td>
                  <td>{item.descricao}</td>
                  <td>
                    {versoes[chave] === undefined ? (
                      <Spinner size="sm" animation="border" />
                    ) : (
                      versoes[chave]
                    )}
                  </td>
                  <td>
                    <Button
                      variant="primary"
                      onClick={() => abrirModal(item, "upload")}
                      disabled={loading}
                      className="me-2"
                    >
                      Enviar Pacote
                    </Button>
                    <Button
                      variant="warning"
                      onClick={() => abrirModal(item, "versao")}
                      disabled={loading}
                    >
                      Alterar Versão
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      {/* Modal */}
      <Modal show={modalOpen} onHide={fecharModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {modo === "upload" ? "Enviar Atualização" : "Alterar Versão"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Nome</Form.Label>
              <Form.Control
                type="text"
                value={itemSelecionado?.nome || ""}
                readOnly
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>CNPJ</Form.Label>
              <Form.Control
                type="text"
                value={itemSelecionado?.cnpj || ""}
                readOnly
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Sistema</Form.Label>
              <Form.Control type="text" value={sistema} readOnly />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Nova Versão</Form.Label>
              <Form.Control
                type="text"
                value={versao}
                onChange={(e) => setVersao(e.target.value)}
              />
            </Form.Group>

            {modo === "upload" && (
              <Form.Group className="mb-3">
                <Form.Label>Arquivo</Form.Label>
                <Form.Control
                  type="file"
                  onChange={(e) => setArquivo(e.target.files[0])}
                />
              </Form.Group>
            )}

            <div className="d-flex justify-content-end">
              <Button
                variant="secondary"
                onClick={fecharModal}
                className="me-2"
                disabled={loading || sucesso}
              >
                Cancelar
              </Button>
              <Button
                variant={modo === "upload" ? "primary" : "warning"}
                type="submit"
                disabled={loading || sucesso}
              >
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Salvando...
                  </>
                ) : sucesso ? (
                  "Sucesso!"
                ) : modo === "upload" ? (
                  "Enviar"
                ) : (
                  "Alterar"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
